import * as React from 'react';
import styles from '../styles/wizards/CreateMeetingTemplateWizard.scss';
import { __, validateForm } from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import AddToMeetingIcon from '../assets/images/add-to-meeting-60x60.svg';
import CreateMeetingTemplateForm from '../forms/create_meeting_template_wizard/CreateMeetingTemplateForm';
import { createMeetingTemplate } from '../redux/actions/table/all_meetings';

const CreateMeetingTemplateWizard = ({ onClose, match }) => {
  const _handleSubmit = (formData) => {
    return validateForm(
      createMeetingTemplate(match.params.meeting, formData).then(() => {
        onClose();

        setTimeout(
          () =>
            setNotification(
              __(
                'meeting.notification.selected-meeting-has-been-added-as-template'
              )
            ),
          25
        );
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.create-meeting-as-template.title')}</span>
          <span>{__('wizard.create-meeting-as-template.subtitle')}</span>
        </div>
        <div className={styles.right}>
          <AddToMeetingIcon />
        </div>
      </div>
      <div className={styles.body}>
        <CreateMeetingTemplateForm onSubmit={_handleSubmit} onClose={onClose} />
      </div>
    </>
  );
};

export default withRouter(
  subscribe(Localization, 'localization')(CreateMeetingTemplateWizard)
);
